import { EXPANDED } from '../../classnames/design-system';

export class ShowMoreToggle {
  constructor(textContainer, toggleBtn) {
    this.textContainer = textContainer;
    this.toggleBtn = toggleBtn;
  }

  checkOverflow = () => {
    if (this.textContainer.scrollHeight > this.textContainer.clientHeight) {
      this.toggleBtn.style.display = 'inline';
    }
  };

  addEventListeners = () => {
    this.toggleBtn.addEventListener('click', this.toggleText);
  };

  toggleText = () => {
    this.textContainer.classList.toggle(EXPANDED);
    this.toggleBtn.textContent = this.textContainer.classList.contains(EXPANDED) ? 'Hide' : 'Show more';
  };

  initialize = () => {
    this.checkOverflow();
    this.addEventListeners();

    new ResizeObserver(this.checkOverflow).observe(this.textContainer);
  };
}
